import { useEffect, useState } from "react";
import appConstants from "../constants/appConstants";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Layout from "../components/Layout";
import axios from "axios";
import { Form, Button, Table, Spinner, Alert } from "react-bootstrap";

const getAuthToken = () => localStorage.getItem("authToken");

const StudentFeeSummary = () => {
  const [batchId, setBatchId] = useState("");
  const [status, setStatus] = useState("Active");
  const [batches, setBatches] = useState([]);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    loadBatches();
  }, []);

  const loadBatches = async () => {
    try {
      const res = await axios.post(
        `${appConstants.API_ROOT_URL}get-batches`,
        {},
        {
          headers: { Authorization: `Bearer ${getAuthToken()}` },
        }
      );
      if (res.data.status === "success") {
        setBatches(res.data.data);
      } else {
        setErrorMsg("Failed to load batches.");
      }
    } catch (err) {
      setErrorMsg("Error loading batches.");
    }
  };

  const fetchStudents = async () => {
    setLoading(true);
    setErrorMsg("");
    try {
      const res = await axios.post(
        `${appConstants.API_ROOT_URL}get-students-fee-summary`,
        {
          batch_id: batchId,
          status,
        },
        {
          headers: { Authorization: `Bearer ${getAuthToken()}` },
        }
      );
      if (res.data.status === "success") {
        setStudents(res.data.data);
      } else {
        setErrorMsg(res.data.message || "Failed to load students.");
      }
    } catch (err) {
      setErrorMsg("Error fetching student data.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div className="container mt-4">
        <h4 className="mb-3">
          <i className="fas fa-money-check-alt me-2"></i>Student Fee Summary
        </h4>

        <div className="d-flex gap-3 flex-wrap align-items-end mb-3">
          <Form.Group>
            <Form.Label>Batch</Form.Label>
            <Form.Select
              value={batchId}
              onChange={(e) => setBatchId(e.target.value)}
            >
              <option value="">Select Batch</option>
              {batches.map((batch) => (
                <option key={batch.id} value={batch.id}>
                  {batch.class_name} {batch.division}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="Active">Active</option>
              <option value="Suspend">Suspend</option>
            </Form.Select>
          </Form.Group>

          <Button
            variant="primary"
            className="mt-2"
            onClick={fetchStudents}
            disabled={!batchId || loading}
          >
            {loading ? <Spinner size="sm" animation="border" /> : "Fetch"}
          </Button>
        </div>

        {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}

        {students.length > 0 && (
          <Table striped bordered hover responsive>
            <thead className="table-dark">
              <tr>
                <th>Sl</th>
                <th>Ad.No</th>
                <th>Name</th>
                <th>Status</th>
                <th>Total Fees</th>
                <th>Paid Fees</th>
                <th>Balance</th>
              </tr>
            </thead>
            <tbody>
              {students.map((stu, index) => {
                const balance =
                  parseFloat(stu.total_fees || 0) -
                  parseFloat(stu.paid_fees || 0);
                return (
                  <tr key={stu.student_id}>
                    <td>{index + 1}</td>
                    <td>{stu.admission_no}</td>
                    <td>{stu.student_name}</td>
                    <td>{stu.status}</td>
                    <td>{parseFloat(stu.total_fees).toFixed(2)}</td>
                    <td>{parseFloat(stu.paid_fees).toFixed(2)}</td>
                    <td>{balance.toFixed(2)}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </div>
    </Layout>
  );
};

export default StudentFeeSummary;
